import {Injectable} from '@angular/core';
import {CoreDataRepository} from "../../repositories/base/core-data.repository";
import {MyStorageService} from "../common/my-storage.service";
import {MbDatatablesTemplate} from "../../components/mb-datatable/mb-datatables-template";
import {RestaurantService} from "../restaurant.service";

@Injectable({
    providedIn: 'root'
})
export class CoreDataService {
    private LANG_KEY = 'languages';
    private CURRENCY_KEY = 'currencies';
    private LOCALIZATION_KEY = 'localizations';

    private _coreDataKey: string = null;

    constructor(private coreDataRepository: CoreDataRepository,
                private restaurantService: RestaurantService,
                private myStorageService: MyStorageService) {
    }

    getListByKey() {
        if (this._coreDataKey == null) {
            throw Error("U not set key for getting data");
        }
        return this.coreDataRepository.getFilterListByKey(this._coreDataKey);
    }

    getAllByKey() {
        if (this._coreDataKey == null) {
            throw Error("U not set key for getting data");
        }
        return this.coreDataRepository.getAllListByKey(this._coreDataKey);
    }

    save(coreData: any) {
        const payload = {
            id: null,
            type: this._coreDataKey,
            attribute: coreData
        };
        return this.coreDataRepository.save(this._coreDataKey, payload);
    }

    update(row: any) {
        const payload = {
            id: row.id,
            type: this._coreDataKey,
            attribute: row
        };
        return this.coreDataRepository.update(this._coreDataKey, payload);
    }

    delete(row: any) {
        return this.coreDataRepository.deleteById(this._coreDataKey, row.id);
    }

    reactivate(row: any) {
        return this.coreDataRepository.reactivateById(this._coreDataKey, row.id);
    }

    validation(coreData: any) {
        if (coreData.name == null || coreData.name.length < 1) {
            throw new Error("error.coreData.name.invalid");
        }
        if (coreData.code == null || coreData.code.length < 1) {
            throw new Error("error.coreData.code.invalid");
        }
    }

    /**
     * STORAGE FUNCTIONS
     */


    async refreshCookiesByCode() {
        let coreData = await this.coreDataRepository.getFilterListByKey(this._coreDataKey).toPromise();
        this.myStorageService.saveToCookies(this._coreDataKey, JSON.stringify(coreData));
    }

    getLanguagesSync() {
        return this.coreDataRepository.getFilterListByKey(this.LANG_KEY);
    }

    getLanguages(): any[] {
        return JSON.parse(this.myStorageService.getFromCookies(this.LANG_KEY, '[]'));
    }

    async storeLanguage() {
        let languages = this.myStorageService.getFromCookies(this.LANG_KEY, []);
        if (languages.length < 1) {
            languages = await this.coreDataRepository.getFilterListByKey(this.LANG_KEY).toPromise();
            this.myStorageService.saveToCookies(this.LANG_KEY, JSON.stringify(languages));
        }
    }

    getCurrencies(): any[] {
        return JSON.parse(this.myStorageService.getFromCookies(this.CURRENCY_KEY, '[]'));
    }

    async storeCurrencies() {
        let currencies = this.myStorageService.getFromCookies(this.CURRENCY_KEY, []);
        if (currencies.length < 1) {
            currencies = await this.coreDataRepository.getFilterListByKey(this.CURRENCY_KEY).toPromise();
            this.myStorageService.saveToCookies(this.CURRENCY_KEY, JSON.stringify(currencies));
        }
    }

    async storeLocalization() {
        let localizations = this.myStorageService.getFromCookies(this.LOCALIZATION_KEY, []);
        if (localizations.length < 1) {
            localizations = await this.coreDataRepository.getFilterListByKey(this.LOCALIZATION_KEY).toPromise();
            this.myStorageService.saveToCookies(this.LOCALIZATION_KEY, JSON.stringify(localizations));
        }
    }

    getLocalizations(): any[] {
        return JSON.parse(this.myStorageService.getFromCookies(this.LOCALIZATION_KEY, '[]'));
    }

    /**
     * GETTER AND SETTER
     */
    get coreDataKey(): string {
        return this._coreDataKey;
    }

    set coreDataKey(value: string) {
        this._coreDataKey = value;
    }

    public defineColumns() {
        return [
            {
                resizeable: false, prop: 'id', name: 'base.id', headerTemplate: MbDatatablesTemplate.HEADER_TEMPLATE,
                input: {type: 'text'}
            },
            {
                resizeable: false,
                prop: 'name',
                name: 'administration.systemLists.name',
                headerTemplate: MbDatatablesTemplate.HEADER_TEMPLATE,
                input: {type: 'text'}
            },
            {
                resizeable: false,
                prop: 'code',
                name: 'administration.coreData.code',
                headerTemplate: MbDatatablesTemplate.HEADER_TEMPLATE,
                input: {type: 'text'}
            },
            {
                resizeable: false,
                prop: 'deleted',
                name: 'administration.coreData.deleted',
                headerTemplate: MbDatatablesTemplate.HEADER_TEMPLATE,
                cellTemplate: MbDatatablesTemplate.TRANSLATE_TEMPLATE,
                input: {
                    type: 'select', options: [
                        {label: 'general.true', value: 'true'},
                        {label: 'general.false', value: 'false'}
                    ], default: 'false'
                }
            },
            {
                resizeable: false,
                prop: 'createdAt',
                name: 'base.createdAt',
                headerTemplate: MbDatatablesTemplate.HEADER_TEMPLATE,
                cellTemplate: MbDatatablesTemplate.DATETIME_TEMPLATE,
                input: {type: 'text'}
            }
        ];
    }


}
